module.exports = __webpack_public_path__ + "static/media/tourismm.88093c6f.png";